import { createContext, useReducer } from "react";

const INITIAL_STATE = {
  vin: "",
  brand: "",
  model: "",
  type: "",
  color: "",
  plate: "",
  driverId: "",
  id: "",
  driverIdModified: "",
};

const VehicleContext = createContext(INITIAL_STATE);

const VehicleReducer = (state, action) => {
  switch (action.type) {
    case "CHANGE_INPUT":
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case "RESET_VALUES":
      return INITIAL_STATE;
    default:
      return state;
  }
};

export const VehicleProvider = (props) => {
  const [state, dispatch] = useReducer(VehicleReducer, INITIAL_STATE);

  return (
    <VehicleContext.Provider value={{ state, dispatch }}>
      {props.children}
    </VehicleContext.Provider>
  );
};

export default VehicleContext;
